import { cn } from '../../lib/cn.js';

export interface TypingIndicatorProps {
  /** Who is typing, for screen readers and the visible caption. */
  label?: string;
  className?: string;
}

/** Three animated dots in an incoming-style bubble: the other side is composing a reply. Motion respects reduced-motion. */
export function TypingIndicator({ label = 'El agente está escribiendo…', className }: TypingIndicatorProps) {
  return (
    <div role="status" aria-live="polite" className={cn('flex justify-end', className)}>
      <div className="grid justify-items-end gap-1">
        <div className="inline-flex items-center gap-1 rounded-card rounded-tr-[4px] border border-border-subtle bg-surface-subtle px-3.5 py-3" aria-hidden>
          {[0, 150, 300].map((d) => (
            <span key={d} className="size-2 rounded-full bg-text-secondary motion-safe:animate-bounce" style={{ animationDelay: `${d}ms` }} />
          ))}
        </div>
        <span className="text-meta text-text-secondary">{label}</span>
      </div>
    </div>
  );
}
